import React, { Suspense } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  redirect,
} from "react-router-dom";
import Login from "./pages/Login";
import Layout from "./Layout";
import LoadingFallBack from "./component/LoadingFallBack";

const Dashboard = React.lazy(() => import("./pages/Dashboard"));

// Loader function to check authentication
const redirectLoader = async () => {
  localStorage.clear();

  // Redirect to login page
  return redirect("/login");
};

const loginLoader = async () => {
  localStorage.clear();

  return null;
};

const authWrapperLoader = async () => {
  const accessKey = localStorage.getItem("access");
  const clientKey = localStorage.getItem("client");
  const token = localStorage.getItem("token");

  if (!accessKey || !clientKey || !token) {
    return redirect("/login");
  }

  return null;
};

const App = () => {
  const routes = createBrowserRouter([
    {
      path: "/",
      // Add the loader to the home route
      loader: redirectLoader,
    },
    {
      path: "/login",
      element: <Login />,
      loader: loginLoader,
    },
    {
      path: "/dashboard",
      loader: authWrapperLoader,
      element: <Layout />,
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<LoadingFallBack />}>
              <Dashboard />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "*",
      element: (
        <div className="h-screen w-full text-white">404 - Page Not Found</div>
      ),

      loader: () => redirect("/login"),
    },
  ]);

  return <RouterProvider router={routes} />;
};

export default App;
